import { render, staticRenderFns } from "./irrigationProportion.vue?vue&type=template&id=3f28ef50&scoped=true"
import script from "./irrigationProportion.vue?vue&type=script&lang=js"
export * from "./irrigationProportion.vue?vue&type=script&lang=js"
import style0 from "./irrigationProportion.vue?vue&type=style&index=0&id=3f28ef50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f28ef50",
  null
  
)

export default component.exports